import { ToastContainer } from 'react-toastify';
import './App.css';
import 'react-toastify/dist/ReactToastify.css'
import Router from './components/Router/Router'
import { AppContextProvider } from './contexts/AppContext';

const App = () => {

  return (
    <AppContextProvider>
      <div className='App'>
        <Router></Router>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme='colored'
        />
      </div>
    </AppContextProvider>
  );
}

export default App;
